import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function PublishDialog({
  open,
  onClose,
  onPublish,
}: {
  open: boolean;
  onClose: () => void;
  onPublish: () => void;
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>カリキュラム公開の確認</DialogTitle>
      <DialogContent>
        <DialogContentText color="error">
          カリキュラムを公開してもよろしいですか？
          <br />
          一度カリキュラムを公開すると、前の状態に戻すことはできません。
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="default" autoFocus>
          キャンセル
        </Button>
        <Button onClick={onPublish} color="default">
          カリキュラムを公開する
        </Button>
      </DialogActions>
    </Dialog>
  );
}
